<template>
  <div class="login">
    <div class="block" v-loading="loading>0" element-loading-text="正在登录">
      <div class="logo">
        <img src="../assets/img/icon/logo.png">
        <span>{{$app_name}}</span>
      </div>
      <el-form label-position="right" :rules="rules" label-width="5em" :model="form" ref="form">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="用户名" @keyup.native.enter="login"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="密码"
                    @keyup.native.enter="login"></el-input>
        </el-form-item>
        <el-button type="primary" class="m-t-10 full-width" @click="login" :loading="loading>0">登录</el-button>
        <!-- 找回密码功能还未实现，暂时隐藏入口
        <div class="text-right m-t-10 m-b--10">
            <router-link :to="$location.retrieve_password()" class="el-button el-button--text">
                忘记密码？
            </router-link>
        </div>
        -->
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from 'api/account'
import * as session from 'common/session'
import * as rules from 'common/rules'

export default {
  data () {
    return {
      form: {username: '', password: ''},
      loading: 0,
      rules: {
        username: [rules.required('请输入用户名')],
        password: [rules.required('请输入密码')],
      },
    }
  },
  methods: {
    async login () {
      if (this.loading) return
      if (!await this.$validate(this.$refs.form)) return
      this.form.username = this.form.username.trim()
      this.loading = true
      try {
        session.set(await login(this.form))
        this.$message.success('登入成功')
        this.$router.replace('/')
      } catch (e) {
        this.$handleError(e, false)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: $color-primary url(../assets/img/background.png) no-repeat 50% 50%;
  background-size: 100% 100%;
  .block {
    padding: 40px 40px 30px;
    width: 500px;
    max-width: 100%;
    text-align: center;
    background-color: $color-block-background;
    .logo {
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 30px;
      color: $color-primary;
      line-height: 1;
      img {
        height: 2em;
        width: 2em;
        vertical-align: middle;
        line-height: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue